export default {
	POST_REGISTER: () => "/auth/register",
	POST_MAGIC_LINK: () => "/auth/magicLink",
	GET_MAGIC_LINK: () => "/auth/magicLink",
	POST_LOGOUT: () => "/auth/logout",
	GET_CSRF_TOKEN: () => "/auth/csrf-token",
};
